declare global {
  interface Window {
    $memberstackDom: any;
  }
}

interface MemberResponse {
  data: {
    customFields: {
      'first-name': string; // Assuming 'first-name' is of type string
    };
    auth: {
      email: string;
    };
    id: string;
    // member: {
    //   name: string;
    //   // Add other properties if you know the structure of 'member'
    // };
  };
}

export class MemberStack {
  //constructor() {
  // if (window.$memberstackDom) {
  //   window.$memberstackDom
  //     .getCurrentMember()
  //     .then((response: MemberResponse) => {
  //       if (response && response.data && response.data.member) {
  //         console.log('member', response.data.member);
  //         // do something with member data here
  //         // init 3rd party analytics, etc.
  //       } else {
  //         console.error('Unexpected response structure:', response);
  //       }
  //     })
  //     .catch((error: any) => {
  //       console.error('Error fetching member:', error);
  //     });
  //}
  //}

  async getMemberName(): Promise<string | null> {
    try {
      const response: MemberResponse = await window.$memberstackDom.getCurrentMember();

      return response.data.customFields['first-name'];
    } catch (error) {
      console.error('Error fetching member name:', error);
      return null;
    }
  }
  async getMemberEmail(): Promise<string | null> {
    try {
      const response: MemberResponse = await window.$memberstackDom.getCurrentMember();
      console.log('response', response);
      return response.data.auth.email;
    } catch (error) {
      console.error('Error fetching member emai;:', error);
      return null;
    }
  }

  async getMemberID(): Promise<string | null> {
    try {
      const response: MemberResponse = await window.$memberstackDom.getCurrentMember();
      return response.data.id;
    } catch (error) {
      console.error('Error fetching member ID:', error);
      return null;
    }
  }
}
